import { useCallback, useEffect, useRef } from 'react';

export function useAutoResizeTextarea<T extends HTMLTextAreaElement>(
  value?: string
) {
  const ref = useRef<T>(null);

  const resize = useCallback(() => {
    const el = ref.current;
    if (el) {
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    }
  }, []);

  useEffect(() => {
    requestAnimationFrame(resize);
  }, [value, resize]);

  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  useEffect(() => {
    const el = ref.current;
    if (!el || !el.parentElement) return;

    const observer = new ResizeObserver(resize);
    observer.observe(el.parentElement);

    return () => observer.disconnect();
  }, [resize]);

  return ref;
}
